var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C4.14 15 1 11.859 1 8C1 4.14 4.14 1 8 1C11.859 1 15 4.14 15 8C15 11.859 11.859 15 8 15ZM8 0C12.411 0 16 3.589 16 8C16 12.411 12.411 16 8 16C3.589 16 0 12.411 0 8C0 3.589 3.589 0 8 0ZM11.3534 5.35361C11.4444 5.26261 11.5004 5.1376 11.5004 4.9996C11.5004 4.7236 11.2764 4.4996 11.0004 4.4996C10.8614 4.4996 10.7364 4.55561 10.6464 4.64661L8.0004 7.2926L5.3534 4.64661C5.2634 4.55661 5.1384 4.4996 5.0004 4.4996C4.7234 4.4996 4.5004 4.7236 4.5004 4.9996C4.5004 5.1376 4.5564 5.26261 4.6464 5.35361L7.2934 7.9996L4.6464 10.6466C4.5564 10.7366 4.5004 10.8616 4.5004 10.9996C4.5004 11.2756 4.7234 11.4996 5.0004 11.4996C5.1384 11.4996 5.2634 11.4436 5.3534 11.3536L8.0004 8.7066L10.6464 11.3536C10.7374 11.4436 10.8624 11.4996 11.0004 11.4996C11.2764 11.4996 11.5004 11.2756 11.5004 10.9996C11.5004 10.8616 11.4444 10.7366 11.3534 10.6466L8.7074 7.9996L11.3534 5.35361Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseInCircle);
export default __webpack_public_path__ + "static/media/closeInCircle.24da4252.svg";
export { ForwardRef as ReactComponent };